var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100 justify-center align-center d-flex",class:_vm.$vuetify.breakpoint.xsOnly ? '' : 'pa-3'},[_c('div',{staticClass:"choose-shelf-wrapper"},[_c('ChooseShelf',{on:{"submit":_vm.selectLocation}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }